import React from "react";
import {useForm} from "react-hook-form";
import axiosInstance from "../services/axios";
import { useNavigate } from "react-router-dom";


function FreestyleDebate(){
    const navigate = useNavigate();
    const {
        handleSubmit,
        register,
        formState: { errors, isSubmitting},
        
    }=useForm();
    const onSubmit = async (values) => {
        const participants_code = Math.random().toString(36).slice(4);
        const audience_code =  Math.random().toString(36).slice(4);
        values.participants_code = participants_code;
        values.audience_code = audience_code;
        const topic = values.topics
        const freestyle_details = [];
        freestyle_details.push({"topics":[[topic]]})
        values.freestyle_details = freestyle_details
        delete values.topic;  
        try{      
            await axiosInstance.post(`/create/`, values);
            navigate("/debates", { replace: true }); // <-- redirect
        }
        catch(err){
            throw(err)
        }
      };

    return (
        <form  action="#" method="POST" className="freestyle" onSubmit={handleSubmit(onSubmit)}>
        <input type="hidden" name="type" value="freestyle" {...register("type")} />
        <div className="form-step-row">
            <div className="form-row-left">
                <label htmlFor="input2">Title of debate</label>
            </div>

            <div className="form-row-right">
                <div className="form-group">
                    <input type="text" className="form-control" id="input2" name="debate_title" placeholder="Enter debate title"  {...register("title", {
                    required: true,
                  })}/>
                    {errors.title && <span className="error-message">Title is required</span>}
                 
                </div>
             
            </div>

        </div>

        <div className="form-step-row">
            <div className="form-row-left">
                <label htmlFor="input3">Time of debate</label>
            </div>

            <div className="form-row-right">
                <div className="form-group">
                    <div className="form-control time-input-div d-flex align-items-center">
                        <input type="text" min="0" max="23" placeholder="00" maxLength="2" name="total_hour" {...register("total_hour", {
                            required: "Date is required",
                        })}/>

                        <span>hr</span>
                        <input type="text" min="0" max="59" placeholder="00" maxLength="2" name="total_minutes" {...register("total_minutes", {
                        required: 'hour required',
                        })}/>
                        <span>min</span>
                        <img src={process.env.PUBLIC_URL+"img/timer-watch-icon-black.png"} className="icon" alt="" title="" width="16" />
                    </div>
                    {errors.total_hour && <span className="error-message">Hour is required </span>}
                    {errors.total_minutes && <span className="error-message">Minute is required</span>}

                </div>
              

            </div>
        </div>

        <div className="form-step-row form-step-top-align">
            <div className="form-row-left">
                <label htmlFor="input4">Topic of debate</label>
            </div>

            <div className="form-row-right" >
                <div id="topic_form" >
                    <div className="form-group mb-3">
                        <input type="text" className="form-control" id="input4-0" name="topics" placeholder="Enter debate topic"  {...register("topics", {
                    required: "This is required field",
                  })}/>
                  {errors.topics && <span className="error-message">Topic is required</span>}

                        {/* <span className="delete">Delete</span> */}
                    </div>
                </div>

                <div className="form-group d-flex justify-content-end mt-2" >
                    <a id="add_on" style={{cursor: "pointer", display:"none"}}  className="add-topic">+ Add topic</a>
                </div>
            </div>
        </div>

        <div className="form-step-row form-step-less-space">
            <div className="form-row-left">
                <label>No. of members on each side</label>
            </div>

            <div className="form-row-right">
                <div className="radio-input mr-2">
                    <input type="radio" id="member1" name="noOfMembers" value="1" {...register("members_each_side")}/>
                    <label htmlFor="member1">1</label>
                </div>

                <div className="radio-input mr-2">
                    <input type="radio" id="member2" name="noOfMembers" value="2" {...register("members_each_side")}/>
                    <label htmlFor="member2">2</label>
                </div>

                <div className="radio-input mr-2">
                    <input type="radio" id="member3" name="noOfMembers" value="3" {...register("members_each_side")}/>
                    <label htmlFor="member3">3</label>
                </div>

                <div className="radio-input mr-2">
                    <input type="radio" id="member4" name="noOfMembers" value="4" {...register("members_each_side")}/>
                    <label htmlFor="member4">4</label>
                </div>

                <div className="radio-input">
                    <input type="radio" id="member5" name="noOfMembers"  value="5" {...register("members_each_side")}/>
                    <label htmlFor="member5">5</label>
                </div>
            </div>
            {errors.members_each_side && <span className="error-message">Member is required</span>}

        </div>

        <div className="form-step-row last">
            <div className="form-row-left">
            </div>

            <div className="form-row-right">
                <input type="submit" className="btn btn-primary"  value="Finish" />
            </div>
        </div>
    </form>
    );
}

export default FreestyleDebate;